// Prefer the MapEditor-owned protocol so the app can run with micro-app disableSandbox.
// __MICRO_APP_PUBLIC_PATH__ is kept only as a compatibility fallback for sandbox mode.
const bootstrapData = window.__MAP_EDITOR_BOOTSTRAP_DATA__ || {};
const publicPath =
  bootstrapData.assetBaseUrl ||
  window.__MAP_EDITOR_ASSET_BASE_URL__ ||
  window.__MICRO_APP_PUBLIC_PATH__;

if (publicPath) {
  // eslint-disable-next-line
  __webpack_public_path__ = /\/$/.test(publicPath) ? publicPath : `${publicPath}/`;
}
